.footer-links {
  @media screen and (min-width: 768px) {
    display: flex;
    flex-flow: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
}

.footer-links__list {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--wb-spacing-xs, 1rem);

  &__item {
    font-weight: 400;
    margin-left: 10px;
  }
}
